import { formatEntityTagsLabel } from '@/features/shared/tags';
import { InfoField } from '@/ui/composites/InfoField';
import { Section } from '@/ui/layout/Section';
import { Surface } from '@/ui/primitives';
import type { ReactElement } from 'react';

type EntityTagsMetadataSectionProps = {
  tags: string[] | undefined;
};

export const EntityTagsMetadataSection = ({
  tags,
}: EntityTagsMetadataSectionProps): ReactElement => (
  <Section paddingY="md">
    <Surface padding="lg" border>
      <InfoField label="Tags" value={formatEntityTagsLabel(tags)} gap="none" />
    </Surface>
  </Section>
);
